// Minimal country/state data for the address form.
// Replaces `country-state-city` for the 16 countries listed in
// address_controller's `allowedCountries`. Countries without an entry in
// STATES return an empty array, which address_controller renders as a
// free-text input — the same behavior the old library produced for
// countries with no subdivision data.

const COUNTRIES = [
  { isoCode: "US", name: "United States", phonecode: "1" },
  { isoCode: "CA", name: "Canada", phonecode: "1" },
  { isoCode: "GB", name: "United Kingdom", phonecode: "44" },
  { isoCode: "AU", name: "Australia", phonecode: "61" },
  { isoCode: "FR", name: "France", phonecode: "33" },
  { isoCode: "DE", name: "Germany", phonecode: "49" },
  { isoCode: "NZ", name: "New Zealand", phonecode: "64" },
  { isoCode: "IE", name: "Ireland", phonecode: "353" },
  { isoCode: "ES", name: "Spain", phonecode: "34" },
  { isoCode: "IT", name: "Italy", phonecode: "39" },
  { isoCode: "JP", name: "Japan", phonecode: "81" },
  { isoCode: "NL", name: "Netherlands", phonecode: "31" },
  { isoCode: "CH", name: "Switzerland", phonecode: "41" },
  { isoCode: "SG", name: "Singapore", phonecode: "65" },
  { isoCode: "SE", name: "Sweden", phonecode: "46" },
  { isoCode: "TR", name: "Turkey", phonecode: "90" }
]

// State ISO codes match what Google Places returns as `short_name` for
// `administrative_area_level_1`, so the autocomplete fill-in continues to
// match dropdown options.
const STATES = {
  US: [
    ["AL", "Alabama"], ["AK", "Alaska"], ["AZ", "Arizona"], ["AR", "Arkansas"],
    ["CA", "California"], ["CO", "Colorado"], ["CT", "Connecticut"], ["DE", "Delaware"],
    ["DC", "District of Columbia"], ["FL", "Florida"], ["GA", "Georgia"], ["HI", "Hawaii"],
    ["ID", "Idaho"], ["IL", "Illinois"], ["IN", "Indiana"], ["IA", "Iowa"],
    ["KS", "Kansas"], ["KY", "Kentucky"], ["LA", "Louisiana"], ["ME", "Maine"],
    ["MD", "Maryland"], ["MA", "Massachusetts"], ["MI", "Michigan"], ["MN", "Minnesota"],
    ["MS", "Mississippi"], ["MO", "Missouri"], ["MT", "Montana"], ["NE", "Nebraska"],
    ["NV", "Nevada"], ["NH", "New Hampshire"], ["NJ", "New Jersey"], ["NM", "New Mexico"],
    ["NY", "New York"], ["NC", "North Carolina"], ["ND", "North Dakota"], ["OH", "Ohio"],
    ["OK", "Oklahoma"], ["OR", "Oregon"], ["PA", "Pennsylvania"], ["RI", "Rhode Island"],
    ["SC", "South Carolina"], ["SD", "South Dakota"], ["TN", "Tennessee"], ["TX", "Texas"],
    ["UT", "Utah"], ["VT", "Vermont"], ["VA", "Virginia"], ["WA", "Washington"],
    ["WV", "West Virginia"], ["WI", "Wisconsin"], ["WY", "Wyoming"]
  ],
  CA: [
    ["AB", "Alberta"], ["BC", "British Columbia"], ["MB", "Manitoba"],
    ["NB", "New Brunswick"], ["NL", "Newfoundland and Labrador"],
    ["NT", "Northwest Territories"], ["NS", "Nova Scotia"], ["NU", "Nunavut"],
    ["ON", "Ontario"], ["PE", "Prince Edward Island"], ["QC", "Quebec"],
    ["SK", "Saskatchewan"], ["YT", "Yukon"]
  ]
}

const COUNTRY_BY_CODE = Object.fromEntries(COUNTRIES.map(c => [c.isoCode, c]))

export function getAllCountries() {
  return COUNTRIES
}

export function getCountryByCode(code) {
  return COUNTRY_BY_CODE[code] || null
}

export function getStatesOfCountry(countryCode) {
  const rows = STATES[countryCode]
  if (!rows) return []
  return rows.map(([isoCode, name]) => ({ isoCode, name, countryCode }))
}
